export const ServerHost = 'miglet.mygolf2u.com';
export const ServerPort = 443;
export const ServerProtocol = 'https';

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBiMsxq9fT6OW7xRiH3JqQat_QgMr4XhNY',
    authDomain: 'mygolf2u-1211.firebaseapp.com',
    databaseURL: 'https://mygolf2u-1211.firebaseio.com',
    projectId: 'mygolf2u-1211',
    storageBucket: 'mygolf2u-1211.firebasestorage.app',
    messagingSenderId: '1040445445221',
    appId: '1:1040445445221:web:eb9ca4fe460cee1c07e28c',
    vapidKey:
      'BMkCtQmcoZTxK0QjVPFwLLw3B7mkGP2FEp2fqBGnv8i4K62yezualXiCvxeFgyT0dj1AivIAV8yxLyl-lEcHMI0',
  },
  firebaseSW: 'firebase-messaging-sw.js',
};
